import React, { useMemo } from 'react';
import { useStores } from 'src/utils/useStore';
import { ModuleProps } from 'src/utils/module-util';
import { checkValue } from 'src/components/common/helper';
import { HotelWidgetGraphsComponent } from 'src/components/common/modules/expedia-deals/hotel/hotel-widget/code-split/hotel-widget-graphs-component';
import { MultiHotelsWidgetComponent } from 'src/components/common/modules/expedia-deals/hotel/multi-hotel-widget/code-split/multi-hotels-widget-component';
import { VrboHotelCarouselWidgetComponent } from 'src/components/common/modules/v1/hotel-carousel-widget/vrbo/code-split/hotel-carousel-widget-component';
import { CpCmsLiteHotelCarouselWidgetComponent } from 'src/components/common/modules/v1/hotel-carousel-widget/code-split/hotel-carousel-widget-component';

// Css Style Import
import(/* webpackChunkName: "expedia-hotel-inventory-card-styles" */ 'src/components/common/modules/expedia-deals/hotel/styles/hotel-inventory-card.css');
import(/* webpackChunkName: "expedia-hotel-widget-styles" */ 'src/components/common/modules/expedia-deals/hotel/hotel-widget/styles/hotel-widget.css');

const HotelModule = (props: ModuleProps) => {
  const hotelWidgetProps = {
    ...props,
    data: {
      ...props?.data,
      ...props,
      mccidData: { ...props.mccidData },
    },
  };

  return (
    <>
      <HotelWidgetGraphsComponent {...hotelWidgetProps} />
    </>
  );
};

const TabbedDealsModule = (props: ModuleProps) => {
  const multiHotelsWidgetProps = useMemo(() => {
    if (
      checkValue(props?.data?.dealList, true) &&
      checkValue(props?.data?.randomiseTabOrder) &&
      props?.data?.randomiseTabOrder === 'True'
    ) {
      // Fisher-Yates shuffle algorithm
      for (let i = props.data.dealList.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [props.data.dealList[i], props.data.dealList[j]] = [props.data.dealList[j], props.data.dealList[i]];
      }
    }

    const updatedData = {
      ...props?.data,
      ...props,
      mccidData: { ...props.mccidData },
    };

    return {
      ...props,
      data: updatedData,
    };
  }, [props]);

  return (
    <>
      <MultiHotelsWidgetComponent {...multiHotelsWidgetProps} />
    </>
  );
};

const HotelDealsCarouselModule = (props: ModuleProps) => {
  const {
    context: { site },
  } = useStores();

  if (!checkValue(props?.data)) {
    return null;
  }

  const hotelWidgetProps = {
    data: {
      cTACopy: props.data.cTAText,
      cTAUrl: props.data.cTAUrl,
      checkInDate: props.data.checkInDate,
      checkOutDate: props.data.checkOutDate,
      conciergeLocalization: undefined,
      hotelIds: props.data.hotelIds,
      backgroundColor: props.data.backgroundColor,
      hotelCtaText: props.data.hotelCtaText,
      destination: props.data.destination,
      mccidData: { ...props.mccidData },
      module: props.data.module,
      propertyCount: props.data.propertyCount,
      subheadline: props.data.subheadline,
      title: props.data.headline,
      uniquekey: props.data.uniquekey,
      dealSortOrder: props?.data?.dealSortOrder,
      filterByReviews4Stars: props?.data?.filterByReviews4Stars,
      cTAColor: props?.data?.cTAColor,
      cTATextColor: props?.data?.cTATextColor,
      paymentType: props?.data?.paymentType
    },
    defaultSetting: props.defaultSetting,
    isWebflow: false,
  };

  const isVrbo = site?.brand === 'vrbo';
  const hasHotelIds = checkValue(props?.data?.hotelIds);
  const hasTripBoard = hasHotelIds && props?.data?.hotelIds?.indexOf('trip-board') > -1;
  const hasDestination = checkValue(props?.data?.destination);

  const isVrboOwnGraphQLHotelData = isVrbo && (hasTripBoard || hasDestination);

  return (
    <>
      {isVrboOwnGraphQLHotelData ? (
        <VrboHotelCarouselWidgetComponent {...hotelWidgetProps} />
      ) : (
        <CpCmsLiteHotelCarouselWidgetComponent {...hotelWidgetProps} />
      )}
    </>
  );
};

export { HotelModule, TabbedDealsModule, HotelDealsCarouselModule };
